var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlancClavier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 525.89 279.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-5 {\n        fill: none;\n      }\n\n      .cls-2, .cls-5 {\n        stroke-width: .75px;\n      }\n\n      .cls-2, .cls-6 {\n        stroke: #e63d11;\n      }\n\n      .cls-7 {\n        fill: #894900;\n      }\n\n      .cls-8, .cls-6 {\n        fill: #e63d11;\n      }\n\n      .cls-9 {\n        fill: url(#D\xE9grad\xE9_sans_nom_5);\n      }\n\n      .cls-3 {\n        stroke-width: 7px;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        stroke: #fff;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-12 {\n        opacity: .4;\n      }\n\n      .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-18 {\n        fill: #f39100;\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-20 {\n        fill: #00376b;\n      }\n\n      .cls-21 {\n        fill: url(#D\xE9grad\xE9_sans_nom_5-3);\n      }\n\n      .cls-22 {\n        fill: url(#D\xE9grad\xE9_sans_nom_5-2);\n      }\n\n      .cls-23 {\n        isolation: isolate;\n      }\n\n      .cls-4, .cls-24 {\n        fill: #fff;\n      }\n\n      .cls-4, .cls-6 {\n        stroke-width: .5px;\n      }\n\n      .cls-13 {\n        fill: url(#D\xE9grad\xE9_sans_nom_3-4);\n      }\n\n      .cls-25 {\n        fill: #8a94ae;\n      }\n\n      .cls-26 {\n        opacity: .8;\n      }\n\n      .cls-27 {\n        fill: url(#D\xE9grad\xE9_sans_nom_11);\n      }\n\n      .cls-15 {\n        fill: url(#D\xE9grad\xE9_sans_nom_3-2);\n      }\n\n      .cls-15, .cls-16 {\n        opacity: .6;\n      }\n\n      .cls-16 {\n        fill: url(#D\xE9grad\xE9_sans_nom_3-3);\n      }\n\n      .cls-28 {\n        fill: url(#D\xE9grad\xE9_sans_nom_11-3);\n      }\n\n      .cls-29 {\n        fill: url(#D\xE9grad\xE9_sans_nom_11-2);\n      }\n\n      .cls-17 {\n        fill: url(#D\xE9grad\xE9_sans_nom_3);\n        opacity: .5;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    x: 382.16,
    y: 156,
    width: 152.64,
    height: 136.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.67,
    dy: 5.67
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3",
    "data-name": "D\\xE9grad\\xE9 sans nom 3",
    x1: 442.88,
    y1: 190.18,
    x2: 460.02,
    y2: 190.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3-2",
    "data-name": "D\\xE9grad\\xE9 sans nom 3",
    x1: 469,
    y1: 187.12,
    x2: 463.65,
    y2: 191.33,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3-3",
    "data-name": "D\\xE9grad\\xE9 sans nom 3",
    x1: 442.27,
    y1: 205.05,
    x2: 462.43,
    y2: 205.05,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_3-4",
    "data-name": "D\\xE9grad\\xE9 sans nom 3",
    x1: 470.2,
    y1: 204.3,
    x2: 481.95,
    y2: 204.3,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 467.97,
    y1: 208.05,
    x2: 454.64,
    y2: 217.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1b84b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 452.8,
    y1: 186.74,
    x2: 439.47,
    y2: 196.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 459.81,
    y1: 196.59,
    x2: 446.48,
    y2: 206.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_11",
    "data-name": "D\\xE9grad\\xE9 sans nom 11",
    x1: 489.6,
    y1: 188.09,
    x2: 466.27,
    y2: 208.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_11-2",
    "data-name": "D\\xE9grad\\xE9 sans nom 11",
    x1: 466.14,
    y1: 175.56,
    x2: 450.57,
    y2: 189.25,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_11-3",
    "data-name": "D\\xE9grad\\xE9 sans nom 11",
    x1: 475.45,
    y1: 182.74,
    x2: 458.99,
    y2: 197.22,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_5",
    "data-name": "D\\xE9grad\\xE9 sans nom 5",
    x1: 464.64,
    y1: 209.73,
    x2: 441.65,
    y2: 221.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_5-2",
    "data-name": "D\\xE9grad\\xE9 sans nom 5",
    x1: 453.08,
    y1: 186.5,
    x2: 436.71,
    y2: 194.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_5-3",
    "data-name": "D\\xE9grad\\xE9 sans nom 5",
    x1: 458.63,
    y1: 197.65,
    x2: 435.64,
    y2: 209.09,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "384.03 158.06 384.03 170.41 384.43 170.41 403.78 170.41 403.8 152.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M61,35.18c1.54-1.87,3.56-4.02,6.16-6.16,2.32-1.91,4.56-3.36,6.51-4.45h23.71c.9.59,2.21,1.5,3.68,2.74,6.19,5.22,9.14,11.13,11.13,15.24,5.63,11.6,8.44,17.4,10.62,22.26,2.28,5.11,5.67,12.48,10.1,21.38l21.4-52.89c.41-1.19,1.63-4.24,4.79-6.51,2.06-1.47,4.09-2.01,5.29-2.23h23.54c1.89.41,5.74,1.55,8.49,4.97,3.42,4.25,3.06,9.47,2.74,14.04-.19,2.69-.82,6.93-3.07,11.8l-41.1,72.78v53.76h-35.91c-.79-.27-1.96-.76-3.13-1.71-2.96-2.4-3.69-5.89-4.11-7.88-.25-1.18-.5-2.95-.34-5.14v-38.69L61,35.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M229.98,73.93c6.33,0,11.47,5.14,11.47,11.47s-5.14,11.47-11.47,11.47-11.47-5.14-11.47-11.47,5.14-11.47,11.47-11.47ZM220.09,105.56h19.77v64.06h-19.77v-64.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M316.61,160.65c-.23-.43-.44-.87-.63-1.32M317.34,161.89c-.26-.4-.5-.82-.73-1.24M357.81,163.09v-1.4h-.26c-.2.32-.41.63-.63.92M315.97,159.33c-.99-2.28-1.53-4.88-1.53-7.79,0-22.14,26.89-22.54,43.36-22.54,0-6.99-5.8-11.47-12.65-11.47-6.46,0-11.86,2.9-16.08,7.64l-10.54-10.81c7.25-6.85,17.79-10.28,28.21-10.28,23.07,0,29.26,11.73,29.26,33.08v21.79M352.93,141.65c-6.06,0-19.51.53-19.51,9.23,0,4.75,5.01,6.99,9.36,6.99,7.78,0,15.03-4.09,15.03-12v-4.22h-4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M190.63,70.51h19.77v99.65h-19.77v-99.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.03,157.02v-50.87h19.77v10.28h.26c4.22-7.78,9.75-11.86,18.45-11.86,2.24,0,4.75.13,6.59.66v18.06c-2.77-.79-5.54-1.32-8.44-1.32-15.03,0-16.87,8.7-16.87,21.49v9.09"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 444.73,
    cy: 116.67,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.79,159.68v-20.67c0-7.38-.13-16.87-10.28-16.87s-11.86,8.04-11.86,16.34v31.9h-19.77v-64.06h18.98v8.7h.26c2.64-5.01,9.1-10.28,18.72-10.28,20.03,0,23.72,13.18,23.72,30.32v24.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "289.77 159.99 289.77 170.38 309.56 170.38 309.56 159.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "356.92 164.14 356.92 170.41 375.99 170.41 375.99 160.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "189.77 182.41 243.2 182.41 290.22 162.66 351.72 162.66 407.27 148.69 438.05 123.82"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M411.58,190.78c-8.03-1.88-15.81-7.1-19.97-14.23-.15,7.47,1.27,15.87,4.7,22.51,1.74,3.37,3.48,7.57,7.13,10.1-1.03,5.5-2.08,15.44,1.69,26.5,6.59,19.35,24.82,32.99,44.57,36,1.72.26,31.91,4.33,51.43-18.86,2.26-2.68,16.72-20.46,12-44.57-5.21-26.62-29.2-37.49-31.71-38.57-23.63-10.21-48.48-.28-61.85,11.94-3.65,3.34-6.24,6.65-7.98,9.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M434.91,237.8c-1.67,1.8-3.92,2.81-6.62,2.81-5.53,0-8.42-3.28-8.42-7.98s3.01-8.13,8.44-8.13c2.81,0,4.93.89,6.58,2.76l-2.27,2.27c-1.01-1.38-2.43-2.1-4.31-2.1-3.57,0-5.08,2.21-5.08,5.2s1.42,5.03,5.07,5.03c1.88,0,3.36-.74,4.39-2.08l2.23,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M454.51,240.42h-3.24v-.7h-.04c-.91.6-2.17.89-3.42.89-2.41,0-5.53-.87-5.53-4.02,0-3.71,5.07-4.08,8.17-4.08.1,0,1.15,0,1.27.02l-.51-.31c-.08-1.03-1.01-1.55-2.46-1.55-1.22,0-2.48.29-3.59,1.03l-2-2.02c1.67-1.18,3.55-1.69,5.63-1.69,3.3,0,5.73,1.46,5.73,4.81v7.61ZM451.76,235.1c-.12-.02-.84-.02-.92-.02-.52,0-1.03,0-1.69.04-.64.02-1.32.08-1.92.21-1.22.25-1.73.68-1.73,1.3,0,.89,1.16,1.28,2.43,1.28.99,0,3.34-.12,3.34-1.34v-1.16l.49-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M469.51,228.17l-5.45,12.23h-2.93l-5.43-12.23h3.59l2.68,6.56.93,2.16-.08-1.13,3.11-7.6h3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M474.23,240.4h-3.24v-12.23h3.24v12.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M489.4,235.55h-10.19l.72.31c.47,1.24,1.59,2.06,3.26,2.06,1.22,0,2.21-.37,3.18-1.16l1.96,1.98c-1.46,1.26-3.11,1.86-5.14,1.86-4.52,0-6.71-2.74-6.71-6.21,0-3.67,2.39-6.4,6.54-6.4s6.46,2.83,6.46,6.4c0,.31-.02.78-.08,1.16ZM486.5,232.95l-.49-.31c-.45-1.28-1.44-2-2.99-2s-2.54.76-3.05,2l-.56.31h7.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M498.33,230.99c-2.29,0-3.34,1.07-3.34,3.36v6.05h-3.24v-12.23h3.24v1.63h.04c.7-1.11,1.9-1.77,3.55-1.77h1.22l-1.48,2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M472.62,227.04c-1.05,0-1.75-.78-1.75-1.79s.7-1.79,1.75-1.79,1.75.78,1.75,1.79-.72,1.79-1.75,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M439.21,224.11c-.98,0-1.78-.23-2.42-.63v16.93h3.24v-16.25l-.09-.09c-.23.03-.48.04-.73.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M471.14,250.15c0-2.31-1.54-4.66-4.45-4.66s-4.73,2.24-4.73,5.22,1.91,5.26,4.8,5.26c1.68,0,3.14-.63,4.1-2.14l-.9-.8c-.61,1.08-1.93,1.77-3.18,1.77-2.87,0-3.59-2.68-3.59-3.75h7.95v-.91ZM463.19,249.89c0-.52.76-3.24,3.44-3.24,1.82,0,3.28,1.47,3.28,3.24h-6.72ZM451.61,242.5h1.23v5h.04c.49-1.1,1.7-2.01,3.24-2.01,2.95,0,3.61,2.11,3.61,4.29v5.93h-1.23v-5.87c0-1.62-.43-3.19-2.38-3.19-1.82,0-3.28,1.34-3.28,4.08v4.98h-1.23v-13.22ZM450.2,254.25c-.92,1.17-2.13,1.73-3.48,1.73-2.91,0-4.98-2.2-4.98-5.24s2.07-5.24,4.98-5.24c1.37,0,2.6.63,3.52,1.73l-.98.78c-.72-.82-1.56-1.34-2.54-1.34-2.32,0-3.75,1.83-3.75,4.08s1.43,4.08,3.75,4.08c1.02,0,1.91-.56,2.54-1.38l.94.82ZM435.24,241.69h1.18l1.82,2.55h-1.09l-1.36-1.91-1.36,1.91h-.99l1.82-2.55ZM439.5,251.53v-2.44c0-2.52-1.48-3.6-3.77-3.6-1.23,0-2.71.5-3.61,1.4l.72.88c.84-.76,1.78-1.12,2.89-1.12,1.52,0,2.66.69,2.66,2.42v.6h-1.43c-1.86,0-5.25.3-5.25,3.34,0,2.11,1.72,2.96,3.34,2.96s2.62-.6,3.32-1.88h.04c0,.56.04,1.12.12,1.62h1.15c-.14-1.14-.18-2.24-.18-4.19ZM438.39,251.38c0,1.66-.68,3.43-3.3,3.43-1.02,0-2.15-.63-2.15-1.86,0-1.7,2.05-2.24,4.1-2.24h1.35v.67ZM424.93,245.49c-1.41,0-3.03.63-3.79,2.01h-.04v-7.14c-.45-.38-.86-.8-1.23-1.26v16.61h1.23v-1.75h.04c.76,1.38,2.38,2.01,3.79,2.01,2.91,0,4.98-2.2,4.98-5.24s-2.07-5.24-4.98-5.24ZM424.93,254.81c-2.23,0-3.96-1.83-3.96-4.08s1.72-4.08,3.96-4.08,3.75,1.83,3.75,4.08-1.43,4.08-3.75,4.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M442.88,195.27s.22,2.15,1.35,1.02c1.12-1.13,3.44-5.66,10.58-8.8,7.14-3.14,4.87-3.74,4.87-3.74l-4,.96-4.71,2.25-3.67,2.67-3.47,3.36-.8,1.87-.15.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M442.88,195.27s.22,2.15,1.35,1.02c1.12-1.13,3.44-5.66,10.58-8.8,7.14-3.14,4.87-3.74,4.87-3.74l-4,.96-4.71,2.25-3.67,2.67-3.47,3.36-.8,1.87-.15.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M467.02,183.17s-.66-.33-.64.19c.02.52-1.32,4.23-10.51,9.11-9.19,4.88,1.13,5.23,1.13,5.23l11.31-4.04,1.75-6.69-2-2.97-.54-.58-.49-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M467.02,183.17s-.66-.33-.64.19c.02.52-1.32,4.23-10.51,9.11-9.19,4.88,1.13,5.23,1.13,5.23l11.31-4.04,1.75-6.69-2-2.97-.54-.58-.49-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M449.52,212.48s1.06.78,1.37-.66c.34-1.41,3.01-3.91,12.9-11.03,9.89-7.13-5.61-.75-5.61-.75l-6.88,2.13-4.38,5.5,1.88,3.94.56.75.16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M449.52,212.48s1.06.78,1.37-.66c.34-1.41,3.01-3.91,12.9-11.03,9.89-7.13-5.61-.75-5.61-.75l-6.88,2.13-4.38,5.5,1.88,3.94.56.75.16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M476.43,199.15l.39-.73v-.38s0-.6-.43-.22c-.42.38-1.84,1.74-8.71,9.1-6.88,7.36,2.04,2.24,2.04,2.24l5.21-4.38,1.81-4.49-.31-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M476.43,199.15l.39-.73v-.38s0-.6-.43-.22c-.42.38-1.84,1.74-8.71,9.1-6.88,7.36,2.04,2.24,2.04,2.24l5.21-4.38,1.81-4.49-.31-1.15Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M455,211.53c1.63-1.06,4.02-2.08,5.94-2.9,8.76-3.74,15.12-6.74,15.87-10.58,0,.21.01.41.01.62,0,9.47-7.67,17.14-17.14,17.14-1.91,0-3.75-.31-5.46-.89-1.67-.83-1.41-1.96.78-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M459.68,181.53c1.13,0,2.23.11,3.29.32.87.32,1.06.81.5,1.42-.86.94-3.08,1.87-6.44,3.28-7.57,3.16-12.74,5.53-14.16,8.72,1.58-7.84,8.5-13.74,16.8-13.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M459.73,203.51c-8.04,3.56-12.59,6.34-10.2,8.97-3.4-2.51-5.85-6.25-6.67-10.56.26-4.13,7.37-7.56,15.92-11.27,5.98-2.59,11.44-5.29,8.25-7.47,3.72,1.76,6.7,4.82,8.36,8.6.56,3.25-3.87,6.53-15.65,11.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M455,211.53c1.63-1.06,4.02-2.08,5.94-2.9,8.76-3.74,15.12-6.74,15.87-10.58,0,.21.01.41.01.62,0,9.47-7.67,17.14-17.14,17.14-1.91,0-3.75-.31-5.46-.89-1.67-.83-1.41-1.96.78-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M459.68,181.53c1.13,0,2.23.11,3.29.32.87.32,1.06.81.5,1.42-.86.94-3.08,1.87-6.44,3.28-7.57,3.16-12.74,5.53-14.16,8.72,1.58-7.84,8.5-13.74,16.8-13.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M459.73,203.51c-8.04,3.56-12.59,6.34-10.2,8.97-3.4-2.51-5.85-6.25-6.67-10.56.26-4.13,7.37-7.56,15.92-11.27,5.98-2.59,11.44-5.29,8.25-7.47,3.72,1.76,6.7,4.82,8.36,8.6.56,3.25-3.87,6.53-15.65,11.74Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M455,211.53c1.63-1.06,4.02-2.08,5.94-2.9,8.76-3.74,15.12-6.74,15.87-10.58,0,.21.01.41.01.62,0,9.47-7.67,17.14-17.14,17.14-1.91,0-3.75-.31-5.46-.89-1.67-.83-1.41-1.96.78-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M459.68,181.53c1.13,0,2.23.11,3.29.32.87.32,1.06.81.5,1.42-.86.94-3.08,1.87-6.44,3.28-7.57,3.16-12.74,5.53-14.16,8.72,1.58-7.84,8.5-13.74,16.8-13.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M459.73,203.51c-8.04,3.56-12.59,6.34-10.2,8.97-3.4-2.51-5.85-6.25-6.67-10.56.26-4.13,7.37-7.56,15.92-11.27,5.98-2.59,11.44-5.29,8.25-7.47,3.72,1.76,6.7,4.82,8.36,8.6.56,3.25-3.87,6.53-15.65,11.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M455,211.53c1.63-1.06,4.02-2.08,5.94-2.9,8.76-3.74,15.12-6.74,15.87-10.58,0,.21.01.41.01.62,0,9.47-7.67,17.14-17.14,17.14-1.91,0-3.75-.31-5.46-.89-1.67-.83-1.41-1.96.78-3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M459.68,181.53c1.13,0,2.23.11,3.29.32.87.32,1.06.81.5,1.42-.86.94-3.08,1.87-6.44,3.28-7.57,3.16-12.74,5.53-14.16,8.72,1.58-7.84,8.5-13.74,16.8-13.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M459.73,203.51c-8.04,3.56-12.59,6.34-10.2,8.97-3.4-2.51-5.85-6.25-6.67-10.56.26-4.13,7.37-7.56,15.92-11.27,5.98-2.59,11.44-5.29,8.25-7.47,3.72,1.76,6.7,4.82,8.36,8.6.56,3.25-3.87,6.53-15.65,11.74Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlancClavier);
export default __webpack_public_path__ + "static/media/Blanc-Clavier.89854f5460813324e466d46994b74b49.svg";
export { ForwardRef as ReactComponent };